import React, { useState, useEffect } from 'react';
import { fetchPerformance } from '../../utils/explorerApi';
import CompletionRateByQuestion from '../performance/CompletionRateByQuestion';
import DropOffFunnel from '../performance/DropOffFunnel';
import TimeToCompleteDistribution from '../performance/TimeToCompleteDistribution';
import ResponsesOverTime from '../performance/ResponsesOverTime';

const SurveyHealthView = ({ view, deploymentId, responses = [] }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!deploymentId || view === 'timing') return;

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchPerformance(deploymentId)
      .then(result => {
        if (!cancelled) {
          setData(result);
          setLoading(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setError(err.message || 'Unknown error');
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [deploymentId, view]);

  // Response timing reads the answers already loaded for this deployment; the
  // performance endpoint carries no timestamps.
  if (view === 'timing') {
    return <div style={{ width: '100%' }}><ResponsesOverTime responses={responses} /></div>;
  }

  if (loading) {
    return (
      <div style={{
        color: '#5F6368',
        padding: 40,
        fontFamily: 'var(--font-family-primary)',
        textAlign: 'center'
      }}>
        Loading survey health…
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        color: '#C62828',
        padding: 40,
        textAlign: 'center'
      }}>
        Couldn't load survey health: {error}
      </div>
    );
  }

  if (!data) {
    return null;
  }

  const renderChart = () => {
    switch (view) {
      case 'completion':
        return <CompletionRateByQuestion data={data} />;
      case 'dropoff':
        return <DropOffFunnel data={data} />;
      case 'duration':
        return <TimeToCompleteDistribution data={data} />;
      default:
        return null;
    }
  };

  return (
    <div style={{ width: '100%' }}>
      {renderChart()}
    </div>
  );
};

export default SurveyHealthView;
